import {
  Box,
  Button,
  SxProps,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
  useTheme,
} from "@mui/material";
import { useIntl } from "react-intl";
import useGlobalContext from "globalProviders/GlobalDataProvider";
import { useNavigate } from "react-router-dom";
import { SkuUserAgreementInfo } from "services/facultyPortalClient";
import { dateToStandardFormat } from "utils/dateUtils";

const getStyles = (theme: Theme): { [key: string]: SxProps } => ({
  table: {
    backgroundColor: theme.palette.gray.main,
  },
  alignRight: {
    display: "flex",
    justifyContent: "flex-end",
  },
  fontBold: {
    fontWeight: "bold",
  },
});

type AgreementExpandedTableProps = {
  skuUserAgreement: SkuUserAgreementInfo;
};

const AgreementExpandedTable = ({
  skuUserAgreement,
}: AgreementExpandedTableProps) => {
  const { formatMessage: t } = useIntl();
  const styles = getStyles(useTheme());
  const navigate = useNavigate();
  const { agreementReviewUrl } = useGlobalContext();

  const viewAgreement = () => {
    navigate(agreementReviewUrl(skuUserAgreement.skuId, skuUserAgreement.id));
  };

  return (
    <TableContainer>
      <Table
        role="table"
        aria-label={t({ id: "agreementDetails" })}
        size="small"
        sx={styles.table}
      >
        <TableHead>
          <TableRow>
            <TableCell sx={styles.fontBold}>{t({ id: "agreement" })}</TableCell>
            <TableCell sx={styles.fontBold}>{t({ id: "dueDate" })}</TableCell>
            <TableCell sx={styles.fontBold}>{t({ id: "status" })}</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>{skuUserAgreement.agreementName}</TableCell>
            <TableCell>
              {dateToStandardFormat(skuUserAgreement.dueDate)}
            </TableCell>
            <TableCell>{skuUserAgreement.statusName}</TableCell>
            <TableCell>
              <Box sx={styles.alignRight}>
                <Button
                  variant="contained"
                  size="small"
                  onClick={viewAgreement}
                >
                  {t({ id: "viewAgreement" })}
                </Button>
              </Box>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default AgreementExpandedTable;
